import { NoiseCancellationIcon } from '@daily/shared/components/Icons/NoiseCancellationIcon';
import { NoiseCancellationIconOn } from '@daily/shared/components/Icons/NoiseCancellationIconOn';
import { LoadingSpinner } from '@daily/shared/components/LoadingSpinner';
import { Tooltip } from '@daily/shared/components/Tooltip';
import { useTheme } from '@daily/shared/contexts/Theme';
import classNames from 'classnames';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { TOOLTIP_DELAY } from '/components/Tray/constant';
import { ToggleText } from '/components/Tray/ToggleText';
import { TrayButton } from '/components/Tray/TrayButton';
import { useAudioProcessor } from '/hooks/useAudioProcessor';
import { useCallConfig } from '/hooks/useCallConfig';
import { robotsClassName } from '/lib/robots';

import { GeneralState } from './Setup';

interface Props {
  micState: GeneralState;
}

export const NoiseCancellationControls: React.FC<Props> = memo(
  ({ micState }) => {
    const { t } = useTranslation();
    const { colors } = useTheme();
    const { enableNoiseCancellationUI } = useCallConfig();
    const {
      handleNoiseCancellationChange,
      noiseCancellationDisabled,
      noiseCancellationOn,
    } = useAudioProcessor();

    if (!enableNoiseCancellationUI) return null;

    return (
      <div className="noise-cancellation-btn-container">
        <Tooltip
          delay={TOOLTIP_DELAY}
          // disabled={noiseCancellationDisabled}
          id="tt-noise-cancellation-controls"
          title={t('audio.enableNoiseCancellation')}
          tabIndex={-1}
        >
          <TrayButton
            id="btn-noise-cancellation"
            className={classNames('btn', robotsClassName('noise-btn'))}
            disabled={micState === 'pending' || noiseCancellationDisabled}
            onClick={() => handleNoiseCancellationChange(!noiseCancellationOn)}
          >
            {noiseCancellationDisabled ? (
              <LoadingSpinner />
            ) : noiseCancellationOn ? (
              <NoiseCancellationIconOn backgroundColor={colors.accent} />
            ) : (
              <NoiseCancellationIcon />
            )}
            <ToggleText
              on={noiseCancellationOn && !noiseCancellationDisabled}
              onText={t('audio.noiseCancellationOnShort')}
              offText={t('audio.noiseCancellationOffShort')}
            />
          </TrayButton>
        </Tooltip>
      </div>
    );
  }
);
NoiseCancellationControls.displayName = 'NoiseCancellationControls';
